module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.phoneInputLabelled) ? _c('input-labelled', {
    attrs: {
      "type": 'tel',
      "label": _vm.phoneInputName,
      "value": _vm.phone,
      "error": _vm.state.phoneError
    },
    on: {
      "input": _vm.phoneChanged,
      "click": _vm.phoneClicked
    }
  }) : _c('input-align-left', {
    attrs: {
      "type": 'tel',
      "placeholder": _vm.phoneInputName,
      "value": _vm.phone,
      "error": _vm.state.phoneError,
      "transparent": _vm.inputTransparent
    },
    on: {
      "input": _vm.phoneChanged,
      "click": _vm.phoneClicked
    }
  }), _vm._v(" "), _c('geetest'), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped login-verify__control-group"
  }, [_c('input-align-left', {
    attrs: {
      "type": 'tel',
      "placeholder": '验证码',
      "value": _vm.smsVerifCode,
      "error": _vm.state.smsVerifCodeError,
      "transparent": _vm.inputTransparent
    },
    on: {
      "input": _vm.smsVerifCodeChanged,
      "click": _vm.smsVerifCodeClicked
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control login-verify__sms-button",
    class: {
      'login-verify__sms-button--primary': !_vm.inputTransparent
    }
  }, [_c('a', {
    staticClass: "button",
    class: _vm.smsRqstButtonClass,
    on: {
      "click": function($event) {
        _vm.smsButtonClicked('sms')
      }
    }
  }, [_vm._v("\n        获取验证码\n        "), (_vm.smsTime > 0) ? [_vm._v("\n          (" + _vm._s(_vm.smsTimeDisplay) + ")\n        ")] : _vm._e()], 2)]), _vm._v(" "), _c('span', {
    staticClass: "help has-text-right login-verify__help"
  }, [_vm._v("\n      收不到验证码？点此接收\n      "), _c('a', {
    class: _vm.smsRqstButtonClass,
    on: {
      "click": function($event) {
        _vm.smsButtonClicked('voice')
      }
    }
  }, [_vm._v("语音验证")])])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75823ae6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75823ae6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/PhoneVerification.vue
// module id = 869
// module chunks = 0